"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/slicedToArray");
var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/createClass");
var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/classCallCheck");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var televisions_json_1 = __importDefault(require("../../fixtures/regexes/device/televisions.json"));
var variable_replacement_1 = require("../../utils/variable-replacement");
var user_agent_1 = require("../../utils/user-agent");
var model_1 = require("../../utils/model");
var TelevisionParser = /*#__PURE__*/_createClass(function TelevisionParser() {
  var _this = this;
  _classCallCheck(this, TelevisionParser);
  this.parse = function (userAgent) {
    var result = {
      type: "",
      brand: "",
      model: ""
    };
    if (!_this.isHbbTv(userAgent)) return result;
    result.type = "television";
    for (var _i = 0, _Object$entries = Object.entries(televisions_json_1.default); _i < _Object$entries.length; _i++) {
      var _ref = _Object$entries[_i];
      var _ref2 = _slicedToArray(_ref, 2);
      var brand = _ref2[0];
      var television = _ref2[1];
      var match = user_agent_1.userAgentParser(television.regex, userAgent);
      if (!match) continue;
      result.brand = brand;
      if ("model" in television && television.model) {
        result.model = model_1.buildModel(variable_replacement_1.variableReplacement(television.model, match)).trim();
      } else if ("models" in television && television.models) {
        var _iterator = _createForOfIteratorHelper(television.models),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var model = _step.value;
            var modelMatch = user_agent_1.userAgentParser(model.regex, userAgent);
            if (!modelMatch) continue;
            result.model = model_1.buildModel(variable_replacement_1.variableReplacement(model.model, modelMatch)).trim();
            break;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      break;
    }
    return result;
  };
  this.isHbbTv = function (userAgent) {
    return user_agent_1.userAgentParser("HbbTV\/([1-9]{1}(?:\.[0-9]{1}){1,2})", userAgent);
  };
});
exports.default = TelevisionParser;